import React from "react";
import Typography from "@mui/material/Typography";
import { Link, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LogoUlo from "../../../components/LogoUlo/LogoUlo";

const SyaratKetentuanPageHeader = () => {
    const theme = useTheme();
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("md"));

    return (
        <>
            <Link
                href="https://ukmlokal.com/"
                rel="noreferrer"
                target="_blank"
            >
                <LogoUlo width="100px" />
            </Link>
            {isLaptopScreen ? (
                <Typography
                    marginTop={2}
                    component="div"
                    textAlign="center"
                    variant="h6"
                    fontWeight="bold"
                >
                    Bergabung dengan UKM{" "}
                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{ color: "#20965F" }}
                        display="inline"
                    >
                        LOKAL
                    </Typography>
                </Typography>
            ) : (
                <>
                    <Typography
                        marginTop={2}
                        textAlign="center"
                        variant="h6"
                        fontWeight="bold"
                    >
                        Bergabung dengan
                    </Typography>
                    <Typography
                        component="div"
                        textAlign="center"
                        variant="h6"
                        fontWeight="bold"
                    >
                        UKM{" "}
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            sx={{ color: "#20965F" }}
                            display="inline"
                        >
                            LOKAL
                        </Typography>
                    </Typography>
                </>
            )}
        </>
    );
};

export default SyaratKetentuanPageHeader;
